import { Situation, UnifiedMonitoringProduct } from '@hakimo-ui/hakimo/types';
import { useState } from 'react';
import { EscalationStep } from '../util';
import Escalation from './Escalation';
import PreEscalate from './PreEscalate';

interface Props {
  siteAddress: string;
  escalationPoints: string[];
  escalationProtocol: string[];
  locationId: string;
  locationAlarmId: string;
  alarmGroupId?: string;
  isEscalated: boolean;
  locationTenantId?: string;
  onCancel: () => void;
  selectedSituation?: Situation;
  onPreEscalationSubmit?: (
    comment: string,
    situation?: string,
    subSituation?: string
  ) => void;
  product?: UnifiedMonitoringProduct;
  escalationId?: string;
  mapEmbedUrl?: string;
  timezone?: string;
}

export function EscalateAlarm(props: Props) {
  const {
    siteAddress,
    escalationPoints,
    escalationProtocol,
    locationId,
    locationAlarmId,
    alarmGroupId,
    isEscalated,
    locationTenantId,
    onCancel,
    selectedSituation,
    onPreEscalationSubmit,
    product,
    escalationId,
    mapEmbedUrl,
    timezone,
  } = props;

  const [escalationStep, setEscalationStep] = useState<EscalationStep>(
    isEscalated ? EscalationStep.ESCALATION : EscalationStep.PRE_ESCALATE
  );

  const navToEscalation = (
    comment?: string,
    situation?: string,
    subSituation?: string
  ) => {
    setEscalationStep(EscalationStep.ESCALATION);
    onPreEscalationSubmit?.(comment ?? '', situation, subSituation);
  };

  return (
    <div className="relative w-full space-y-4">
      {escalationStep === EscalationStep.PRE_ESCALATE && (
        <PreEscalate
          locationId={locationId}
          locationAlarmId={locationAlarmId}
          navToEscalation={navToEscalation}
          onCancel={onCancel}
          selectedSituation={selectedSituation}
          product={product}
        />
      )}
      {escalationStep === EscalationStep.ESCALATION && (
        <Escalation
          locationId={locationId}
          siteAddress={siteAddress}
          escalationPoints={escalationPoints}
          escalationProtocol={escalationProtocol}
          locationTenantId={locationTenantId}
          locationAlarmId={locationAlarmId}
          alarmGroupId={alarmGroupId}
          escalationId={escalationId}
          product={product}
          mapEmbedUrl={mapEmbedUrl}
          timezone={timezone}
        />
      )}
    </div>
  );
}
